import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Customer } from '@inyova/models';
import { TranslateService } from '@ngx-translate/core';

import { Store } from '@ngrx/store';
import * as ProfileActions from '@profile/profile.actions';

import { ToastNotificationService } from '@shared/services/toast-notification.service';

@Component({
  selector: 'app-profile-password',
  styleUrls: ['./profile-password.component.scss'],
  templateUrl: './profile-password.component.html',
  standalone: false
})
export class ProfilePasswordComponent {
  @Input() customer: Customer;
  @Input() enabled2FA: boolean;
  @Input() loading: boolean;
  @Input() location: 'personalDetails' | '2FA' = '2FA';
  @Output() validatePassword = new EventEmitter<string>();

  passwordForm: FormGroup;
  visible = false;
  submitted = false;

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    private toastNotificationService: ToastNotificationService,
    private transalateService: TranslateService
  ) {
    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required]]
    });
  }

  goBack(): void {
    this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen: 'main' }));
  }

  send(): void {
    if (this.passwordForm.invalid) {
      this.submitted = true;
      this.toastNotificationService.show('critical', this.transalateService.instant('personal.error.need_current_pass') as string);
      return;
    }
    this.validatePassword.emit(this.passwordForm.get('password').value as string);
  }
}
